import SIDE_LOGO from './assets/img/side-logo.png';
import SIDE_LOGO_WHITE from './assets/img/side-logo-white.png';
import ERROR from './assets/img/error-bg.png';
import IMAGE_UPLOAD_ERROR from './assets/img/image-error.jpg';
import BLANK_IMAGE from './assets/img/blank_image.png';
import HOME_LOGO from './assets/img/logo.png';
import XAPP_HOME_LOGO from './assets/img/xapplogo.png';
import HOME_LOGO_WHITE from './assets/img/logo-white.png';
import SUN_IMAGE from './assets/img/sun.png';
import MOON_IMAGE from './assets/img/moon.png';
import {LoadingOutlined} from "@ant-design/icons";

import STEP_1_ACTIVE_IMG from './assets/img/stepper_icons/active_user.png';
import STEP_2_ACTIVE_IMG from './assets/img/stepper_icons/active_location.png';
import STEP_3_ACTIVE_IMG from './assets/img/stepper_icons/active_invest.png';
import STEP_4_ACTIVE_IMG from './assets/img/stepper_icons/active_bank.png';
import STEP_5_ACTIVE_IMG from './assets/img/stepper_icons/active_info.png';
import STEP_6_ACTIVE_IMG from './assets/img/stepper_icons/active_upload.png';
import STEP_7_ACTIVE_IMG from './assets/img/stepper_icons/active_hand.png';
import STEP_8_ACTIVE_IMG from './assets/img/stepper_icons/active_second_applicant.png';
import STEP_9_ACTIVE_IMG from './assets/img/stepper_icons/active_schedule.png';

import STEP_1_INACTIVE_IMG from './assets/img/stepper_icons/inactive_user.png';
import STEP_2_INACTIVE_IMG from './assets/img/stepper_icons/inactive_location.png';
import STEP_3_INACTIVE_IMG from './assets/img/stepper_icons/inactive_invest.png';
import STEP_4_INACTIVE_IMG from './assets/img/stepper_icons/inactive_bank.png';
import STEP_5_INACTIVE_IMG from './assets/img/stepper_icons/inactive_info.png';
import STEP_6_INACTIVE_IMG from './assets/img/stepper_icons/inactive_upload.png';
import STEP_7_INACTIVE_IMG from './assets/img/stepper_icons/inactive_hand.png';
import STEP_8_INACTIVE_IMG from './assets/img/stepper_icons/inactive_second_applicant.png';
import STEP_9_INACTIVE_IMG from './assets/img/stepper_icons/inactive_schedule.png';
import REJECT_USER from './assets/img/stepper_icons/reject.png';
import REMARK from './assets/img/stepper_icons/remark.png';

import HOME_PAGE_IMG from './assets/img/home_page_img.png';
import LETS_START_IMG from './assets/img/lets_start_page.png';
import WELCOME_IMG from './assets/img/welcome.svg';
import NEW_ACC_IMG from './assets/img/new_account.png';
import SECOND_APPLICANT_SCREEN from './assets/img/second_applicant_screen.png';

import SVG_IMAGE from './assets/img/camera_rotate.svg';
import VIDEO_CALL_IMG from './assets/img/video_call.png';
import ERROR_500 from './assets/img/error_500.svg';
import ADMIN_WELCOME_IMG from './assets/img/admin_welcome.svg';
import UNDER_CONS_IMG from './assets/img/working.svg';
import INVEST_TEMPLATE_IMG from './assets/img/invest_template.png';
import WITHDRAW_TEMPLATE_IMG from './assets/img/withdraw_template.png';
import TRANSFER_TEMPLATE_IMG from './assets/img/transfer_template.png';
import SWITCH_TEMPLATE_IMG from './assets/img/switch_img.png';
import REQUESTS_IMG from './assets/img/icons/requests.png';
import REQUESTS_SIDEMENU_IMG from './assets/img/icons/requests-side-menu.png';
import JOINT_TEMPLATE from './assets/img/icons/joint-template.png';
import JOINT_TEMPLATE_SIDEMENU_IMG from './assets/img/icons/joint-template-side-menu.png';
import JOINT_ACC_REQUESTS_IMG from './assets/img/icons/users_side_menu.png';
import INVEST_TITLE_IMG from './assets/img/icons/invest_white.png';
import WITHDRAW_TITLE_IMG from './assets/img/icons/withdraw_white.png';
import SWITCH_TITLE_IMG from './assets/img/icons/switch_white.png';
import TRANSFER_TITLE_IMG from './assets/img/icons/transfer_white.png';
import JOINT_ACC_REQUESTS_TITLE_IMG from './assets/img/icons/users_white.png';
import BOOKMARKS from './assets/img/icons/bookmarks.png';

import RECONCILE_IMG from './assets/img/reconcile.png';
import TRANS_HISTORY from './assets/img/transactions.png';
import FORGET_PW_IMG from './assets/img/password_screen.svg';
import RECON_AUTH_IMG from './assets/img/icons/recon_auth.png';
import WELCOME_PAGE_QR from './assets/img/welcome-qr.png';
import WELCOME_PAGE_QR_TEXT from './assets/img/welcome-download-text.png';
import MANAGE_WEALTH_TEXT from './assets/img/manage-wealth-text.png';
import WELCOME_TEXT from './assets/img/welcome-text.png';
import WELCOME_CLIP_PATH_IMG from './assets/img/welcome-clip-path.png';

// import PROPOSAL_FORM from './assets/img/ProposalForm/proposalForm.png';

// import SAMPLE_PDF from './assets/img/ProposalForm/proposalForm.png';

export const sideBarLogoPng = SIDE_LOGO
export const sideBarLogoWhitePng = SIDE_LOGO_WHITE
export const errorPng = ERROR
export const homeLogo = HOME_LOGO
export const xappHomeLogo = XAPP_HOME_LOGO
export const welcomePageQR = WELCOME_PAGE_QR
export const welcomePageQRText = WELCOME_PAGE_QR_TEXT
export const manageWealthText = MANAGE_WEALTH_TEXT
export const welcomeText = WELCOME_TEXT
export const welcomeClipPathImg = WELCOME_CLIP_PATH_IMG
export const homeLogoWhite = HOME_LOGO_WHITE
export const loadingOutlined = <LoadingOutlined style={{fontSize: 24}} spin/>;
// export const proposalForm = PROPOSAL_FORM
export const imageUploadError = IMAGE_UPLOAD_ERROR
export const blankImage = BLANK_IMAGE
export const sunImage = SUN_IMAGE
export const moonImage = MOON_IMAGE

export const step_1_active_img = STEP_1_ACTIVE_IMG
export const step_2_active_img = STEP_2_ACTIVE_IMG
export const step_3_active_img = STEP_3_ACTIVE_IMG
export const step_4_active_img = STEP_4_ACTIVE_IMG
export const step_5_active_img = STEP_5_ACTIVE_IMG
export const step_6_active_img = STEP_6_ACTIVE_IMG
export const step_7_active_img = STEP_7_ACTIVE_IMG
export const step_8_active_img = STEP_8_ACTIVE_IMG
export const step_9_active_img = STEP_9_ACTIVE_IMG

export const step_1_inactive_img = STEP_1_INACTIVE_IMG
export const step_2_inactive_img = STEP_2_INACTIVE_IMG
export const step_3_inactive_img = STEP_3_INACTIVE_IMG
export const step_4_inactive_img = STEP_4_INACTIVE_IMG
export const step_5_inactive_img = STEP_5_INACTIVE_IMG
export const step_6_inactive_img = STEP_6_INACTIVE_IMG
export const step_7_inactive_img = STEP_7_INACTIVE_IMG
export const step_8_inactive_img = STEP_8_INACTIVE_IMG
export const step_9_inactive_img = STEP_9_INACTIVE_IMG

export const home_page_img = HOME_PAGE_IMG
export const lets_start_page_img = LETS_START_IMG
export const welcome_img = WELCOME_IMG
export const video_call_img = VIDEO_CALL_IMG
export const reject_user = REJECT_USER
export const remark = REMARK
export const error_500 = ERROR_500
export const new_acc_img = NEW_ACC_IMG
export const sec_applicant_screen = SECOND_APPLICANT_SCREEN
export const admin_welcome_img = ADMIN_WELCOME_IMG
export const under_cons_img = UNDER_CONS_IMG
export const requests_img = REQUESTS_IMG
export const requests_side_menu_img = REQUESTS_SIDEMENU_IMG
export const joint_template_img = JOINT_TEMPLATE
export const joint_template_side_menu_img = JOINT_TEMPLATE_SIDEMENU_IMG
export const invest_template_img = INVEST_TEMPLATE_IMG
export const withdraw_template_img = WITHDRAW_TEMPLATE_IMG
export const transfer_template_img = TRANSFER_TEMPLATE_IMG
export const switch_template_img = SWITCH_TEMPLATE_IMG
export const reconcile_img = RECONCILE_IMG
export const trans_img = TRANS_HISTORY
export const joint_acc_requests_img = JOINT_ACC_REQUESTS_IMG
export const invest_title_img = INVEST_TITLE_IMG
export const withdraw_title_img = WITHDRAW_TITLE_IMG
export const switch_title_img = SWITCH_TITLE_IMG
export const transfer_title_img = TRANSFER_TITLE_IMG
export const joint_acc_requests_title_img = JOINT_ACC_REQUESTS_TITLE_IMG
export const bookmarks_img = BOOKMARKS
export const forget_pw_img = FORGET_PW_IMG
export const recon_auth = RECON_AUTH_IMG


export const svgImage = SVG_IMAGE

// export const samplePdf = SAMPLE_PDF
